import './Home.scss';

import React, { FunctionComponent, useState } from 'react';

import { AuthContext } from '@justgiving/auth-react';
import BrandingIcon from './BrandingIcon.svg';
import Clockface from './Clockface.svg';
import GenerateReportModal from '../../components/GenerateReportModal/GenerateReportModal';
import { Link } from 'react-router-dom';
import LinkIcon from './LinkIcon.svg';
import { PAGES } from '../../constants/pages';
import PencilIcon from './PencilIcon.svg';
import ReportIcon from './ReportIcon.svg';
import { SideBar } from '../../components/SideBar/SideBar';
import SimpleSharableLinkModal from '../../components/SimpleShareableLink/SimpleShareableLinkModal';
import { useCharityData } from '../../context/charityContext';
import { useChrome } from '../../hooks/useChrome';
import { useContext } from 'react';
import useDocumentTitle from '../../hooks/useDocumentTitle';
import { useTranslation } from 'react-i18next';

const Home: FunctionComponent = () => {
  const { t } = useTranslation();
  const [isReportModalOpen, setIsReportModalOpen] = useState(false);
  const [isSimpleShareableModalOpen, setIsSimpleShareableModalOpen] =
    useState(false);

  useChrome();

  useDocumentTitle(t('home.heading'));

  const auth = useContext(AuthContext);
  const { roles } = auth?.getActivePermission('charity') ?? {};
  const { charity } = useCharityData();
  const operatingCompanyCode = charity?.operatingCompanyCode;
  const showReporting =
    (roles?.includes('admin') || roles?.includes('reports')) &&
    operatingCompanyCode &&
    !['AU', 'NZ'].includes(operatingCompanyCode);

  return (
    <>
      <div className="container jg-space-phms giving-checkout__container">
        <div className="row">
          <main className="col-lg-8">
            <div className="content-box jg-space-mtn">
              <h1 className="jg-h2">{t('home.heading')}</h1>
              <p className="jg-color--empress jg-font-weight-regular">
                {t('home.description')}
              </p>
              <ul className="giving-checkout-home-nav">
                <li className="jg-space-pvsm">
                  <img src={LinkIcon} className="jg-space-mrsm" alt="" />
                  <button
                    className="text-link jg-text--link"
                    type="button"
                    onClick={() => {
                      setIsSimpleShareableModalOpen(true);
                    }}
                  >
                    {t('home.simpleShareableLink')}
                  </button>
                </li>
                <li className="jg-space-pvsm">
                  <img src={PencilIcon} className="jg-space-mrsm" alt="" />
                  <Link
                    to={PAGES.Frequency}
                    data-track="setup-checkout-continue"
                  >
                    {t('home.createNewCustomCheckout')}
                  </Link>
                </li>
                <li className="jg-space-pvsm">
                  <img src={Clockface} className="jg-space-mrsm" alt="" />
                  <Link to={PAGES.LinkLibrary} data-track="open-link-library">
                    {t('home.viewAllCheckouts')}
                  </Link>
                </li>
                <li className="jg-space-pvsm">
                  <img src={BrandingIcon} className="jg-space-mrsm" alt="" />
                  <a href="/charities/branding">
                    {t('home.setupBrandingLink')}
                  </a>
                </li>
                {showReporting && (
                  <li className="jg-space-pvsm">
                    <img src={ReportIcon} className="jg-space-mrsm" alt="" />
                    <button
                      className="text-link jg-text--link"
                      type="button"
                      onClick={() => {
                        setIsReportModalOpen(true);
                      }}
                    >
                      {t('home.yourReportingLink')}
                    </button>
                  </li>
                )}
              </ul>
            </div>
          </main>
          <aside className="col-lg-4">
            <SideBar />
          </aside>
        </div>
      </div>
      {showReporting && (
        <GenerateReportModal
          isOpen={isReportModalOpen}
          onRequestClose={() => setIsReportModalOpen(false)}
        />
      )}
      <SimpleSharableLinkModal
        isOpen={isSimpleShareableModalOpen}
        onRequestClose={() => setIsSimpleShareableModalOpen(false)}
        isDefault
      />
    </>
  );
};

export default Home;
